module.exports = __webpack_public_path__ + "components/page-footer/static/snow-forecast__logo--white-b1104bbaa0f39bb2db87a71bb979f833.png";